import { css } from '@emotion/css';

export const readonlyAlert = css`
	display: flex;
	justify-content: space-around;
	position: sticky !important;
	top: 0;
	z-index: 1000;

	margin-bottom: 0.75em !important;
`;
